import { Type } from '@sinclair/typebox';
import { AccountSchema } from '../account/account.js';
const DebitNormsBaseSchema = Type.Object({
    id: Type.String(),
    projectId: Type.String(),
    accountNumber: Type.Integer(),
    rate: Type.Number(),
    order: Type.Integer(),
});
export const DebitNormsSchema = DebitNormsBaseSchema;
const DebitNormsWithoutAccountNumber = Type.Omit(DebitNormsBaseSchema, ['accountNumber']);
export const DebitNormsAccountSchema = Type.Intersect([
    DebitNormsWithoutAccountNumber,
    Type.Object({
        account: AccountSchema,
    }),
]);
